<template>
  <div
    v-if="badgeType"
    class="absolute right-0 top-[17px] z-[2] bg-gray-secondary px-2.5 py-1.5 text-xs font-bold uppercase leading-normal text-white"
    data-test-id="pdp-social-proof-badge"
  >
    {{ $t(`badge_labels.${badgeType}`) }}
  </div>
</template>

<script setup lang="ts">
import type { PdpSocialProofBadgeType } from '~/composables/usePdpSocialProofBadge'

defineProps<{
  badgeType: PdpSocialProofBadgeType
}>()
</script>
